
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/instrukcje-oferty",
      function () {
        return require("private-next-pages/instrukcje-oferty.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/instrukcje-oferty"])
      });
    }
  